import { render, staticRenderFns } from "./okButtonHidden-editor.vue?vue&type=template&id=32fb9fdd&scoped=true&"
import script from "./okButtonHidden-editor.vue?vue&type=script&lang=js&"
export * from "./okButtonHidden-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb9fdd",
  null
  
)

export default component.exports